<template>
  <div class="header" >
    <div class="title-box">
          <div class="title">{{title}}</div>
    </div>
  </div>
</template>

<style scoped>
.header {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background-color:rgb(64,64,64);
  line-height: 40px;
}
.bgclass {
  position: absolute;
  /* width: 1080px;
  height: 116px; */
  width: 750px;
  height: 100px;
}
.title-left {
  flex: 1;
  position: relative;
}
.imgDiv {
  height: 100px;
  width: 80px;
  justify-content: center;
  /* align-items: center; */
}
.backDiv {
  height: 100px;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
}
.backImg {
  width: 40px;
  height: 40px;
  color: #ffffff;
}
.back-text {
  font-size: 34px;
  color: #00b9f4;
}
.qrImg {
  width: 50px;
  height: 10px;
}
.title-box {
  flex: 2;
  height: 40px;
}
.title {
  /* font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: -0.64px;
  text-align: center;
}
.logo-box {
  flex: 1;
  justify-content: center;
  align-items: center;
}
.logo {

  width: 277px;
  height: 60px;
}
.title-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.rightDiv {
  height: 100px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.codeImg {
  width: 62px;
  height: 62px;
}
</style>
<script>
// const context = weex.requireModule("context");
// const stream = weex.requireModule("stream");
// const getphoneInfo = weex.requireModule("getPhoneInfo");
export default {
  props: {
    titleJson: {
      default: "titlebar.json"
    },
    title:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      leftElement: {
        exist: true,
        back: {
          exist: true,
          src: this.$store.state.imgBaseUrl + "/back@2x.png",
          url: ""
        },

      },
      centerElement: {
        exist: true,
        title: {
          exist: true,
        },
        logo: {
          exist: false,
          src: "./imgs/titlebar/logo.png",
          url: ""
        }
      },
      rightElement: {
        exist: false,
         login: {
          exist: false,
          src: "./imgs/more.png",
          url: ""
        }
      },
      bgcolor: "#ffffff",
      machineOS:""
    };
  },
  created() {
    //获取手机标识码
      // getphoneInfo.getPhoneInfo(data =>{
      //   this.machineOS=JSON.parse(data).machineOS;
      // })
  },
  methods: {
    // Back(){
    //   this.$emit('back')
    // },
    goto(id){
      if(this.machineOS=="Android"){
        this.$store.state.Devflag=false
      }
      context.launchStage(id)
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/NavBar.vue